import React from "react";
import { GlitterSparkles } from "./GlitterSparkles";
type ShippingPolicyPageProps = {
  onBack: () => void;
  onOpenReturnPolicy: () => void;
};
const email = "pickenspassion@gmail.com";
const phoneHref = "tel:+12088813989";
const phoneDisplay = "(208) 881-3989";
const linkClass = "text-[#35dceb] underline decoration-transparent underline-offset-2 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]";
function EmailLink() {
  return <a href={`mailto:${email}`} className={linkClass} data-id="element-293" data-mp="2xbeksuilf5zx">
      {email}
    </a>;
}
function Section({
  heading,
  children
}: {
  heading: string;
  children: React.ReactNode;
}) {
  return <section aria-label={heading} data-id="element-294" data-mp="2of5k7civq1c7">
      <h2 className="text-lg font-semibold text-[#35dceb]" data-id="element-295" data-mp="29jh6mwro81vn">{heading}</h2>
      <div className="mt-2 space-y-3 text-sm leading-6 text-white/80" data-id="element-296" data-mp="29mbruqiidqq4">{children}</div>
    </section>;
}
export function ShippingPolicyPage({
  onBack,
  onOpenReturnPolicy
}: ShippingPolicyPageProps) {
  return <main className="relative min-h-[100dvh] w-full bg-[#10070f] px-4 py-10 text-white sm:px-8 sm:py-14" data-id="element-297" data-mp="35vqzy4z6as3w">
      <GlitterSparkles count={450} data-id="element-298" data-mp="3jv9xk3ucyl1y" />
      <div className="relative mx-auto max-w-3xl" data-id="element-299" data-mp="3ju8o23szq6mc">
        <button type="button" onClick={onBack} className="mb-8 text-sm font-medium text-[#35dceb] underline decoration-transparent underline-offset-4 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#35dceb]" data-id="element-300" data-mp="3ftyfqkhq744b">
          Back to home
        </button>

        <header className="border-b border-[#ff3aa2]/60 pb-6" data-id="element-301" data-mp="2w67hv1jab2a3">
          <h1 className="text-3xl font-semibold tracking-tight text-[#ff5bad] sm:text-4xl" data-id="element-302" data-mp="2w4nyv368ud4m">Shipping Policy</h1>
          <p className="mt-2 text-sm text-white/70" data-id="element-303" data-mp="28e0gfnypc53t">Last Updated: September 30, 2026</p>
        </header>

        <p className="mt-6 text-sm leading-6 text-white/80" data-id="element-304" data-mp="24cyo7r37ctbc">
          Thank you for shopping with Pickens Passion! Please review our shipping information before placing your order.
        </p>

        <div className="mt-8 space-y-8" data-id="element-305" data-mp="cavpe9fi7qub">
          <Section heading="Processing times" data-id="element-306" data-mp="h3ovb0mpl57z">
            <p data-id="element-307" data-mp="h61l1zypkjvl">
              <span className="font-semibold text-white" data-id="element-308" data-mp="m31ribzgzon8">Ready-to-Ship Items:</span> Items that are already made and do not require customization will generally be shipped within 72 hours of purchase.
            </p>
            <p data-id="element-309" data-mp="3pjiexocc6wt9">
              <span className="font-semibold text-white" data-id="element-310" data-mp="3piyv2234lycl">Custom &amp; Made-to-Order Items:</span> Custom or personalized orders may require up to 4 weeks before shipment. This allows time for your item to be created specifically for you.
            </p>
            <p data-id="element-311" data-mp="3a7azdm77ogw">
              Processing time is the time required to prepare your order before it is given to the shipping carrier. Carrier transit time begins after the package has been shipped and is separate from our processing time.
            </p>
          </Section>

          <Section heading="Shipping rates" data-id="element-312" data-mp="2z98675yst0k4">
            <p data-id="element-313" data-mp="2uawvyu4lco1d">
              Shipping charges are calculated during checkout based on the order and available shipping options. The shipping charge shown at checkout will be provided before you complete your purchase.
            </p>
          </Section>

          <Section heading="Tracking" data-id="element-314" data-mp="2kkbwl4h3ffhe">
            <p data-id="element-315" data-mp="2fls8oyixvtme">
              When tracking is available, tracking information will be provided after your order has been shipped. Please allow time for the shipping carrier to scan the package and begin displaying tracking updates.
            </p>
          </Section>

          <Section heading="Delivery times" data-id="element-316" data-mp="26lc8bxxht2lr">
            <p data-id="element-317" data-mp="21mito26gz5k0">
              Delivery dates provided by shipping carriers are estimates and are not guaranteed by Pickens Passion. Once a package has been transferred to the carrier, delays caused by weather, holidays, carrier disruptions, or other circumstances outside our control may affect delivery.
            </p>
          </Section>

          <Section heading="Shipping addresses" data-id="element-318" data-mp="2tn46ae4cv2hw">
            <p data-id="element-319" data-mp="2xnxul8lpmjbb">
              Customers are responsible for providing a complete and accurate shipping address at checkout. Please review your shipping information carefully before submitting your order.
            </p>
            <p data-id="element-320" data-mp="2omge3p4e4fm3">
              If you notice an error in your shipping address, contact us as soon as possible at <EmailLink data-id="element-321" data-mp="29xk960xmripp" /> or call or text{" "}
              <a href={phoneHref} className={linkClass} data-id="element-322" data-mp="29wsc0lodxcxb">
                {phoneDisplay}
              </a>
              . We cannot guarantee that an address can be changed once an order has been processed or shipped.
            </p>
            <p data-id="element-323" data-mp="25wi8rgrz90m5">Additional shipping charges resulting from an incorrect or incomplete address will be the customer&apos;s responsibility.</p>
          </Section>

          <Section heading="Lost, delayed, or missing packages" data-id="element-324" data-mp="1r1u424uei67l">
            <p data-id="element-325" data-mp="1vxiwlo806mue">If tracking shows that your package is delayed or has stopped updating, please contact the shipping carrier using the tracking information provided.</p>
            <p data-id="element-326" data-mp="18bys2dmg15ma">
              If you need assistance with a shipment, you may also contact us at <EmailLink data-id="element-327" data-mp="1mb89fgmdy5ru" />, and we will help provide any available order or tracking information.
            </p>
            <p data-id="element-328" data-mp="1hcevxo73mero">A carrier delay does not automatically mean that a package has been lost.</p>
          </Section>

          <Section heading="Damaged packages" data-id="element-329" data-mp="1vb4r2yacy4de">
            <p data-id="element-330" data-mp="1v9tmiw938sl8">
              If your order arrives damaged, please contact <EmailLink data-id="element-331" data-mp="1r99si1jta53b" /> as soon as possible and include your order information and clear photographs of the package and damaged item(s). We will review the situation and determine the appropriate next steps.
            </p>
          </Section>

          <Section heading="Returns & refunds" data-id="element-332" data-mp="204z7nsuo2389">
            <p data-id="element-333" data-mp="2f0yphv7kvhql">
              All sales are final. Please review our{" "}
              <button type="button" onClick={onOpenReturnPolicy} className={linkClass} data-id="element-334" data-mp="2a12gtinxr24p">
                Return Policy
              </button>{" "}
              for complete information regarding returns, cancellations, and refunds.
            </p>
          </Section>

          <Section heading="Questions" data-id="element-335" data-mp="2m10xv5ylc80d">
            <p data-id="element-336" data-mp="2r1onpob32it0">For questions regarding an order or shipment, contact:</p>
            <address className="not-italic leading-7" data-id="element-337" data-mp="2vswtmad7fm1f">
              <span className="block font-semibold text-white" data-id="element-338" data-mp="2vtoofiyz9fqn">Pickens Passion</span>
              <span className="block" data-id="element-339" data-mp="30qyen0u6xvfj">
                <EmailLink data-id="element-340" data-mp="30u2nwcmijhd2" />
              </span>
              <span className="block" data-id="element-341" data-mp="34sto4sm9zf4e">Idaho Falls, ID 83404</span>
              <span className="block" data-id="element-342" data-mp="39sofex9yq6pz">
                <a href={phoneHref} className={linkClass} data-id="element-343" data-mp="39tpt79id57be">
                  {phoneDisplay}
                </a>{" "}
                — call or text
              </span>
            </address>
          </Section>
        </div>
      </div>
    </main>;
}